import { dataArrowUUpRight } from 'dls-icons-data'
import { createIcon } from '../common'

const IconArrowUUpRight = /*#__PURE__*/createIcon(dataArrowUUpRight)
export default IconArrowUUpRight
